import { Observable } from '@apollo/client';
import { ErrorLink } from '@apollo/client/link/error';
import { ServerError } from '@apollo/client/link/utils/throwServerError';

let refreshingPromise: Promise<void> | undefined;

export const getTokenRefreshLink = (refreshToken: () => Promise<void>) => new ErrorLink(({
	networkError,
	forward,
	operation,
}) => {
	if ((networkError as ServerError)?.statusCode === 496) {
		refreshingPromise = (refreshingPromise ?? refreshToken());

		const observable = new Observable<null>((subscriber) => {
			refreshingPromise?.then(() => {
				refreshingPromise = undefined;

				if (subscriber.closed) {
					return;
				}

				subscriber.next(null);
				subscriber.complete();
			});
		});

		return observable.flatMap(() => forward(operation));
	}
});
